import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BreadCrumbLayoutComponent } from './breadcrumb-layout/breadcrumb-layout.component';
import { BreadCrumbItemViewComponent } from './breadcrumb-layout/breadcrumb-item-view/breadcrumb-item-view.component';
import { BreadCrumbsComponent } from './breadcrumbs.component';
import { ArchiveBreadCrumbsComponent } from './archive-breadcrumbs/archive-breadcrumbs.component';
import { FolderBreadCrumbsComponent } from './folder-breadcrumbs/folder-breadcrumbs.component';
import { LicensingBreadcrumbsComponent } from './licensing-breadcrumbs/licensing-breadcrumbs.component';
import { CommonModule } from '@angular/common';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { OrgMenuModule } from '@go-modules/components/menus/org-menu/org-menu.module';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { ActivityMenuModule } from '@go-modules/components/menus/activity-menu/activity-menu.module';
import { ExpiringLicenseModule } from '@go-modules/components/breadcrumbs/folder-breadcrumbs/expiring-license/expiring-license.module';
import { SettingsBreadCrumbsComponent } from './settings-breadcrumbs/settings-breadcrumbs.component';
import { FolderMenuModule } from '../menus/folder-menu/folder-menu.module';
import {
	LicensePlanBreadcrumbModule
} from '@go-modules/components/breadcrumbs/folder-breadcrumbs/license-plan-breadcrumb/license-plan-breadcrumb.module';
import { AiTrialBadgeComponent } from './folder-breadcrumbs/ai-trial-badge/ai-trial-badge.component';
import { BadgeModule } from '@go-modules/components/badge/badge.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		OrgMenuModule,
		FolderMenuModule,
		MenuModule,
		ActivityMenuModule,
		ExpiringLicenseModule,
		LicensePlanBreadcrumbModule,
		BadgeModule
	],
	declarations: [
		BreadCrumbLayoutComponent,
		BreadCrumbItemViewComponent,
		BreadCrumbsComponent,
		ArchiveBreadCrumbsComponent,
		FolderBreadCrumbsComponent,
		LicensingBreadcrumbsComponent,
		SettingsBreadCrumbsComponent,
		AiTrialBadgeComponent
	],
	exports: [
		BreadCrumbLayoutComponent,
		BreadCrumbItemViewComponent,
		BreadCrumbsComponent,
		ArchiveBreadCrumbsComponent,
		FolderBreadCrumbsComponent,
		LicensingBreadcrumbsComponent,
		SettingsBreadCrumbsComponent,
		AiTrialBadgeComponent
	]
})
export class BreadcrumbsModule {}
